import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Params, ResolveFn } from '@angular/router';
import { ResponsePortalAddonApartmentDtoPageResponse } from '../../../../../../../generated/apex-rest';
import { PortalAddonOrdersService } from '../service/portal-addon-orders.service';

export const PortalAddonApartmentsResolver: ResolveFn<ResponsePortalAddonApartmentDtoPageResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const service = inject(PortalAddonOrdersService);

  const projectId = Number(route.paramMap.get('ProjectId'));
  const apartmentId = Number(route.paramMap.get('ApartmentId'));

  const { page, limit } = route.queryParams;

  const params: Params = {
    page: page || 0,
    limit: limit || 100,
  };

  return service.readAddonApartments(projectId, apartmentId, params.page, params.limit);
};
